export default {
    methods: {
        isNotProduction() {
            if (typeof this.$root.config.VUE_APP_ANONYMOUS_CHAT === 'string') {
                return this.$root.config.VUE_APP_ANONYMOUS_CHAT === 'true';
            }
            return this.$root.config.VUE_APP_ANONYMOUS_CHAT;
        },
        isDocumentCompositionEnabled() {
            if (typeof this.$root.config.VUE_APP_DOCUMENT_COMPOSITION === 'string') {
                return this.$root.config.VUE_APP_DOCUMENT_COMPOSITION === 'true';
            }
            return this.$root.config.VUE_APP_DOCUMENT_COMPOSITION;
        }
    }
}